import { render, staticRenderFns } from "./dierge.vue?vue&type=template&id=b4048d98&scoped=true&"
import script from "./dierge.vue?vue&type=script&lang=js&"
export * from "./dierge.vue?vue&type=script&lang=js&"
import style0 from "./dierge.vue?vue&type=style&index=0&id=b4048d98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4048d98",
  null
  
)

export default component.exports